@@ -0,0 +1,69 @@
<template>
  <div class="app-wrap">
    <header id='header'>
      <div class='inner'>
        <div class='col col1'>
          <a class='btnNavi prev'>
            <span @click.stop.prevent='backBtn' class='ico'>이전</span>
          </a>
        </div>
        <div class='col col2'>
          <h1>공지사항</h1>
        </div>
      </div>
    </header>
    <div v-if="list.length > 0">
      <div v-for="(list, index) in list" :key="index" class="noticeList" @click="noticeDetail(list.noticeSeq)">
        <div class="noticeTitle">{{list.noticeTitle}}<div class="arrow"/></div>
        <div class="noticeRegDt">{{list.regDt}}</div>
      </div>
    </div>
    <div class="noMenu" v-else>
      <img src="../assets/img/ic_error_36.png" >
      <p>공지사항이 없습니다</p>
    </div>
  </div>
</template>

<script>
import service from '@/backend/modnpay_app_api'
export default {
  components: { },
  data () {
    return {
      list: {}
    }
  },
  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
    this.noticeList()
  },
  methods: {
    backBtn () {
      history.back()
    },
    async noticeList () {
      const req = {
        displayType: '13' // 관리자에서 관리하는 온누리오더 앱 구분 값
      }
      const { data } = await service.noticeList(req)
      if (data.resultCode == 0) {
        this.list = data.noticeList
        this.noticeSeq = data.noticeList.noticeSeq
      }
    },
    noticeDetail (seq) {
      this.$router.push({ name: 'AppNoticeDetail', params: { noticeSeq: seq } })
    }
  }
}
</script>

<style scoped>
.noMenu{
  height: calc(100% - 32px);
}
</style>
